import axios from "axios";
import { Representative } from "src/common/types/representative";
import { handleApiError } from "src/common/api/apiErrorHandler";

export default class RepresentativesApi {
  static async getRepresentatives(
    reasonId?: number,
    branchId?: number,
    filterByReasonOnly?: boolean
  ): Promise<Representative[]> {
    let url = reasonId && branchId ? `${this.baseUrl}/${reasonId}/${branchId}` : "/api/ServiceReps";

    if (filterByReasonOnly) {
      url = url + "?filterByReasonOnly=true";
    }

    try {
      const response = await axios.get<Representative[]>(url);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  static async validateRepresentative(email: string): Promise<boolean> {
    const url = `${this.baseUrl}/isvalid?email=${email}`;
    try {
      const response = await axios.get<boolean>(url);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  static async getServiceRepsForResourceReport(reasonId: string, branchName: string): Promise<Representative[]> {
    const url = `${this.baseUrl}/getRepsForResourceReport?reasonId=${reasonId}&branchName=${branchName}`;
    try {
      const response = await axios.get<Representative[]>(url);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  private static baseUrl: string = "/api/ServiceReps";
}
